// extracted by mini-css-extract-plugin
module.exports = {"container":"c13sOHf","img":"A9y6pk","itemLink":"kx3whR"};